import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FiltrosPropuestaOperacion } from 'app/models/FiltrosPropuestaOperacion';
import { AccesoService } from 'app/services/acceso/acceso.service';
import { LocalService } from 'app/services/storage/localService';
import { SessionStorageService } from 'app/services/storage/sessionStorage.service';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { filter, pluck } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PropuestaOperacionService {
  readonly urlBase = environment.rutaBase;
  header: HttpHeaders;
  idEmpresa_Factor: any;
  message: Observable<any>;

  constructor(
    private http: HttpClient,
    private accesoService: AccesoService,
    private sessionStorageService: SessionStorageService,
    private localService: LocalService
  ) {
    this.header = this.accesoService.desencriptarTOKEN();
    this.datoStorage();
  }

  datoStorage() {
    this.message = this.sessionStorageService.storageChange$.pipe(
      filter(({ storageArea }) => storageArea === "sessionStorage"),
      filter(({ key }) => key === '1cefada07eb9',),
      pluck("value")
    );
    this.message.subscribe(val => this.idEmpresa_Factor = val - this.localService.getJsonValue('numeroRandom'))
    if (this.idEmpresa_Factor == undefined) {
      this.idEmpresa_Factor = Number(sessionStorage.getItem('1cefada07eb9')) - this.localService.getJsonValue('numeroRandom')
    }
  }

  ObtenerListaPropuestaOperacion(Filtros: FiltrosPropuestaOperacion) {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/ObtenerPropuestasOperacion?NumeroPagina=1&NumeroRegistro=100000&idEmpresa_Factor=${this.idEmpresa_Factor}&RucAdq=${Filtros.RucAdq}&RucProv=${Filtros.RucProv}&Estado=${Filtros.Estado}&TipoServicio=${Filtros.TipoServicio}&FDesde=${Filtros.FDesde}&FHasta=${Filtros.FHasta}&User=${Filtros.user_id}`, { headers });
  }

  ObtenerPropuestaOperacionPorId(IdPropuestaOperacion: any) {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/ObtenerPropuestaOperacionPorID?idEmpresa_Factor=${this.idEmpresa_Factor}&idPropuestaOperacion=${IdPropuestaOperacion}`, { headers });
  }

  ObtenerPropuestaOperacionDetallePorId(IdPropuestaOperacion: any) {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/ObtenerPropuestaOperacionDetallePorID?idEmpresa_Factor=${this.idEmpresa_Factor}&idPropuestaOperacion=${IdPropuestaOperacion}`, { headers });
  }

  CrearPropuestaOperacion(body: any) {
    let headers = this.header;
    return this.http.post(`${this.urlBase}/CrearPropuestaOperacion?idEmpresa_Factor=${this.idEmpresa_Factor}`, body, { headers });
  }

  ObtenerObservacionesPropuestaOperacion(idPropuestaOperacion: number) {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/ObtenerObservacionesEvaluacionPorID?idEmpresa_Factor=${this.idEmpresa_Factor}&idPropuestaOperacion=${idPropuestaOperacion}`, { headers });
  }

  CrearObservacionesPropuestaOperacion(bodyObservacion: any) {
    let headers = this.header;
    return this.http.post(`${this.urlBase}/CrearObservacionEvaluacion?idEmpresa_Factor=${this.idEmpresa_Factor}`, bodyObservacion, { headers });
  }

  ActualizarPropuestaOperacion(body: any) {
    let headers = this.header;
    return this.http.put(`${this.urlBase}/ActualizarPropuestaOperacion?idEmpresa_Factor=${this.idEmpresa_Factor}`, body, { headers });
  }

  obtenerItemsPropuestaOperacion(idPropuestaOperacion?: number) {
    let headers = this.header;
    if (!idPropuestaOperacion) idPropuestaOperacion = 0;
    return this.http.get(`${this.urlBase}/ObtenerItemsProspecto?idEmpresa_Factor=${this.idEmpresa_Factor}&idPropuestaOperacion=${idPropuestaOperacion}`, { headers });
  }
}
